const countryCodeToFlag = (code: string) =>
  code
    .toUpperCase()
    .split("")
    .map((char) => String.fromCodePoint(char.charCodeAt(0) + 0x1f1a5))
    .join("");

export { countryCodeToFlag };
